import React from 'react';
import { Alert } from 'reactstrap';
import { IoClose } from 'react-icons/io5';
import unknownErrorToString from '../../lib/unknownErrorToString';

interface DisplayQueryErrorProps {
    error: unknown;
    refetch?: () => void;
}

const DisplayQueryError: React.FC<DisplayQueryErrorProps> = ({
    error,
    refetch
}) => {
    if (!error) {
        return null;
    }

    const errorMessage = unknownErrorToString(error);

    return (
        <Alert color='danger' className='position-relative'>
            {refetch && (
                <button
                    onClick={() => refetch()}
                    className='position-absolute top-0 end-0 p-2 bg-transparent border-0 text-secondary'
                    style={{ cursor: 'pointer' }}
                    aria-label='Retry'
                >
                    <IoClose size={20} />
                </button>
            )}
            <h6 className='mb-1'>Query error</h6>
            <p className='mb-0'>{errorMessage}</p>
        </Alert>
    );
};

export default DisplayQueryError;
